export const getCoinList = async (currency) => {
	try {
		const res = await fetch(`/api/coin-data/coin-list?quote=${currency}`);
		const response = await res.json();
		return response.data;
	} catch (error) {
		console.error(error);
	}
};
